import React from 'react';
import { Helmet } from 'react-helmet';
import AnimatedBackground from '../components/AnimatedBackground';
import ArticleStructuredData from '../components/ArticleStructuredData';
import PersonalArchivistsHeader from '../components/PersonalArchivistsHeader';

import PersonalArchivistsHero from './personal-archivists/PersonalArchivistsHero';
import Workflow from './personal-archivists/Workflow';
import PainPoints from './personal-archivists/PainPoints';
import LocalFirst from './personal-archivists/LocalFirst';
import Pricing from './personal-archivists/Pricing';
import PersonalArchivistsFAQ from './personal-archivists/PersonalArchivistsFAQ';
import ContactInfo from './personal-archivists/ContactInfo';

const PAGE_TITLE =
  'Sortio for Home: AI File Organizer for Photos, Tax Returns, and Family Documents';
const PAGE_DESCRIPTION =
  'Organize family photos by year, sort decades of tax documents, consolidate duplicate wedding galleries, and clean up your Downloads folder. Sortio is an AI file organizer for Mac that reads what is inside every file and files it where it belongs. Free to try. Preview every move first, and keep photos and tax returns fully local with Ollama if you choose.';
const CANONICAL = 'https://www.getsortio.com/for-personal-archivists';

const PersonalArchivistsPage = () => {
  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        <meta
          name="keywords"
          content="organize family photos by year, organize tax documents, AI file organizer for home, sort decades of files, organize iCloud photos automatically, consolidate wedding photo folders, rename PDFs by content, tax document organizer Mac, house build document organizer, family archive software, downloads folder cleanup, HEIC photo organizer, dedup family photos"
        />
        <link rel="canonical" href={CANONICAL} />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:url" content={CANONICAL} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.getsortio.com/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESCRIPTION} />
      </Helmet>

      <ArticleStructuredData
        title={PAGE_TITLE}
        description={PAGE_DESCRIPTION}
        datePublished="2026-05-12T00:00:00.000Z"
        dateModified="2026-05-12T00:00:00.000Z"
        authorName="Sortio Team"
      />

      <PersonalArchivistsHeader />
      <PersonalArchivistsHero />

      <div className="relative">
        <AnimatedBackground variant="business" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
          <Workflow />
          <PainPoints />
          <LocalFirst />
          <Pricing />
          <PersonalArchivistsFAQ />
          <ContactInfo />
        </div>
      </div>
    </>
  );
};

export default PersonalArchivistsPage;
